import React from "react";
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux';
import { Helmet } from "react-helmet";
import { toast } from 'react-toastify';
import { Link } from "react-router-dom";
import { Player } from '@lottiefiles/react-lottie-player';

import '../css/lesson.css';
import View from '../../../Admin/Lessons/View';
import configData from "../../../Config/QuestionLevel.json";
import effectData from "../../../Config/effect.json";
import soundData from "../../../Config/Sound.json";
import Loading from "../../../Loading";
import { fetchLesson } from '../../../Admin/Lessons/actions';
import { startExam, saveExamAnswer } from '../../../Admin/Exams/actions';
import QuestionView from '../../../Admin/Question/View/QuestionView';
import CountdownCircle from '../../../Admin/Countdown';
import Rate from "../Rate";
import api from "../../../../api/api";
import { studentLiveObserver } from '../../../../../realtime/services/StudentLiveObserver';
import ShowQuestionModal from "./ShowQuestionModal";
import { fetchIndices } from '../../../Admin/Indices/actions/';
import history from '../../../../history';

class ExamView extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isMission: false,
            FontSize: 18,
            hideRate: false,
            showRate: false,
            showSound: false,
            showText: false,
            styleQuestion: '',
            styleBind: '',
            styleText: '',
            first: true,
            showResult: false,
            showEndExam: false,
            ShowQuestionResult: false,
            showEndQuizePage: false,
            showQuestionModal: false,
            showClock: false,
            showTimesUp: false,
            isTimeFinish: false,
            question: null,
            yourTime: 0,

            Id: 0,
            Name: '',
            Bio: '',
            Sort: 0,
            Sound: '',
            Url: '',
            Icon: '',
            Background: '',
            Questions: [],
            IsActive: true,
            IsPublic: false,
            IndexId: 0,
            questionSeparated: {
                BorderStyle: "dashed",
                BorderColor: 'rgba(68, 68, 68, 1)',
                BorderWidth: 3,
                width: 100
            },
            Clock: {
                TimeBorderColor: 'rgba(146, 39, 143, 1)',
                BackgroundBorderColor: 'rgba(255, 255, 255, 1)',
                TimeType: "continue",
                TimeMinutes: 0,
                TimeHour: 0
            },
            MaterialsObject: []
        };
        this._toastId = new React.createRef();
        this.Finish_Sound = soundData.Finish_Sound;
        this.examBackground = effectData.exam;
        this.times_up = effectData.times_up;
        this.duration = 0;
        this.yourTime = 0;
        this.audio = new Audio();
    }

    showSound = showSound => {
        this.setState({ showSound });
    }

    componentWillUnmount() {
        if (this.audio && !this.audio.paused) {
            this.audio.pause();
        }
    }

    componentDidMount() {
        if (this.props.match) {
            const { id } = this.props.match.params;
            this.setState({
                Id: id
            });
            if (id !== '0') {
                this.props.fetchLesson(id, true);
            }
        }
        if (this.props.duration) {
            this.duration = this.props.duration;
        }
        setInterval(() => {
            this.duration -= 1;
            this.yourTime += 1;
            if (this.duration === 0) {
                this.timesUp();
            }
        }, 1000);

        this.props.fetchIndices();
    }

    static getDerivedStateFromProps(props, state) {

        if (props.lessons && props.lessons.current && ((state.Id && state.Id !== '0') || props.isMission === true)) {

            if (props.lessons && props.lessons.code && props.lessons.code === "no_permission") {
                history.push(`/NoPermissions/`);
                return "";
            }
            let lesson = props.lessons.current;

            if (!state.showPagesModal && !state.showLessonInfoModal) {

                let FontSize = 18;
                let questionSeparated = state.questionSeparated;
                let Clock = state.Clock;
                let ExamBackground = state.ExamBackground;
                let MaterialsObject = state.MaterialsObject;

                if (lesson.CustomStyle) {
                    if (lesson.CustomStyle.FontSize) {
                        FontSize = lesson.CustomStyle.FontSize;
                    }
                    if (lesson.CustomStyle.questionSeparated) {
                        questionSeparated = lesson.CustomStyle.questionSeparated;
                    }
                    if (lesson.CustomStyle.Clock) {
                        Clock = lesson.CustomStyle.Clock;
                    }
                    if (lesson.CustomStyle.ExamBackground) {
                        ExamBackground = lesson.CustomStyle.ExamBackground;
                    }
                    if (lesson.CustomStyle.MaterialsObject) {
                        MaterialsObject = lesson.CustomStyle.MaterialsObject;
                    }
                }

                let LessonPage = [];
                if (lesson.LessonPage) {
                    let toRemove = props.lessons.PageToRemove;
                    lesson.LessonPage.sort((a, b) => a.Sort - b.Sort).forEach(item => {
                        if (!toRemove || !toRemove.includes(item.Id)) {
                            LessonPage = [...LessonPage, item];
                        }
                    });
                }

                state = {
                    Sort: lesson.Sort,
                    Id: lesson.Id,
                    Name: lesson.Name,
                    Bio: lesson.Bio,
                    Background: lesson.Background,
                    Sound: lesson.Sound,
                    IsActive: lesson.IsActive,
                    IsPublic: lesson.IsPublic,
                    IndexId: lesson.Index ? lesson.Index.Id : state.IndexId,
                    Icon: lesson.Icon,
                    Url: lesson.Url,
                    LessonPage: LessonPage,
                    Questions: lesson.Questions ? lesson.Questions.sort((a, b) => a.Sort - b.Sort) : [],
                    FontSize,
                    questionSeparated,
                    Clock,
                    ExamBackground,
                    MaterialsObject,
                    first: false
                };

                if (state.Questions) {
                    var hasRight = state.Questions.some(p => p.Position === true);
                    var hasLeft = state.Questions.some(p => p.Position === false);
                    if (hasRight && !hasLeft) {
                        state = {
                            ...state,
                            styleQuestion: {
                                style: {
                                    display: 'none'
                                }
                            },
                            styleBind: {
                                style: {
                                    display: 'none'
                                }
                            },
                            styleText: {
                                style: {
                                    width: '100%'
                                }
                            }
                        };
                    } else if (!hasRight && hasLeft) {
                        state = {
                            ...state,
                            styleQuestion: {
                                style: {
                                    width: '100%'
                                }
                            },
                            styleBind: {
                                style: {
                                    display: 'none'
                                }
                            },
                            styleText: {
                                style: {
                                    display: 'none'
                                }
                            }
                        };
                    } else {
                        state = {
                            ...state,
                            styleQuestion: {},
                            styleBind: {},
                            styleText: {}
                        };
                    }
                }

            } else {
                state.Questions = lesson.Questions ? lesson.Questions.sort((a, b) => a.Sort - b.Sort) : [];

                let LessonPage = [];
                if (lesson.LessonPage) {
                    let toRemove = props.lessons.PageToRemove;
                    lesson.LessonPage.sort((a, b) => a.Sort - b.Sort).forEach(item => {
                        if (!toRemove || !toRemove.includes(item.Id)) {
                            LessonPage = [...LessonPage, item];
                        }
                    });
                }
                state.LessonPage = LessonPage;
                state.first = false;

                if (lesson.CustomStyle) {
                    if (lesson.CustomStyle.questionSeparated) {
                        state.questionSeparated = lesson.CustomStyle.questionSeparated;
                    }
                    if (lesson.CustomStyle.Clock) {
                        state.Clock = lesson.CustomStyle.Clock;
                    }
                    if (lesson.CustomStyle.ExamBackground) {
                        state.ExamBackground = lesson.CustomStyle.ExamBackground;
                    }
                    if (lesson.CustomStyle.MaterialsObject) {
                        state.MaterialsObject = lesson.CustomStyle.MaterialsObject;
                    }
                }

                if (lesson.Questions && lesson.Questions.length !== 0) {
                    var hasRights = lesson.Questions.some(p => p.Position === true);
                    var hasLefts = lesson.Questions.some(p => p.Position === false);
                    if (hasRights && !hasLefts) {
                        state = {
                            ...state,
                            styleQuestion: {
                                style: {
                                    display: 'none'
                                }
                            },
                            styleBind: {
                                style: {
                                    display: 'none'
                                }
                            },
                            styleText: {
                                style: {
                                    width: '100%'
                                }
                            }
                        };
                    } else if (!hasRights && hasLefts) {
                        state = {
                            ...state,
                            styleQuestion: {
                                style: {
                                    width: '100%'
                                }
                            },
                            styleBind: {
                                style: {
                                    display: 'none'
                                }
                            },
                            styleText: {
                                style: {
                                    display: 'none'
                                }
                            }
                        };
                    } else {
                        state = {
                            ...state,
                            styleQuestion: {},
                            styleBind: {},
                            styleText: {}
                        };
                    }
                }
            }

            if (props.isMission) {
                if (props.lessons.current.CustomStyleMission) {
                    state.Clock = {
                        ...state.Clock,
                        TimesUpSound: state.Clock.TimesUpSound ? state.Clock.TimesUpSound : 'random',
                        ...props.lessons.current.CustomStyleMission.Clock
                    }
                }
            }

            const arrayConfetti = [
                process.env.PUBLIC_URL + "/assets/effect/success/61528-confetti.json",
                process.env.PUBLIC_URL + "/assets/effect/success//53513-confetti.json"
            ];
            state.src = arrayConfetti[Math.floor(Math.random() * arrayConfetti.length)];

            if (lesson.CustomStyle?.ExamBackground) {
                const Confetti = lesson.CustomStyle.ExamBackground.Confetti;
                const CustomConfetti = lesson.CustomStyle.ExamBackground.CustomConfetti;

                if (Confetti !== 'custom' && Confetti !== 'none') {
                    if (Confetti === 'random') {
                        state.srcStartPage = effectData.exam[Math.floor(Math.random() * effectData.exam.length)].url;
                    } else {
                        state.srcStartPage = process.env.PUBLIC_URL + Confetti;
                    }
                } else if (Confetti === 'custom' && CustomConfetti) {
                    state.srcStartPage = CustomConfetti;
                }

                if (props.isMission) {
                    state.srcStartPage = effectData.exam[Math.floor(Math.random() * effectData.exam.length)].url;
                }
            }
        }
        state.Id = props.match && props.match.params ? props.match.params.id : props.Id;
        return state;
    }

    timesUp = () => {
        if (this.state.Clock && this.state.showEndExam === false) {

            if (this.state.Clock.TimesUpSound) {
                if (this.state.Clock.TimesUpSound !== '' && this.state.Clock.TimesUpSound !== 'custom' && this.state.Clock.TimesUpSound !== 'none') {
                    let sound = this.state.Clock.TimesUpSound;
                    if (this.state.Clock.TimesUpSound === 'random') {
                        sound = this.Finish_Sound[Math.floor(Math.random() * this.Finish_Sound.length)].url;
                    }
                    this.audio = new Audio(process.env.PUBLIC_URL + sound);
                    this.audio.loop = false;
                    this.audio.play();
                } else if (this.state.Clock.TimesUpSound !== '' && this.state.Clock.TimesUpSound === 'custom' && this.state.Clock.questionSound.CustomTimesUpSound !== '') {
                    this.audio = new Audio(this.props.question.CustomStyle.questionSound.CustomTimesUpSound);
                    this.audio.loop = false;
                    this.audio.play();
                }
            }

            if (this.state.Clock.TimeType === "stoped") {
                this.setState({
                    showClock: false,
                    showTimesUp: true,
                    isTimeFinish: true,
                });
                this.showEndExam();
            } else if (this.state.Clock.TimeType === "continue") {
                const { t } = this.props;
                this._toastId.current = toast(t('Processing'), {
                    position: "bottom-left",
                    autoClose: false
                });
                toast.update(this._toastId.current, {
                    render: () => <div>
                        <div className="h5"> <i className="icon fal fa-hourglass-end"></i> {t('Pages.Exams.toast.TimesUpd.Title')}</div>
                        <div className="h6">{t('Pages.Exams.toast.TimesUpd.Body')}</div>
                    </div>,
                    type: toast.TYPE.DARK,
                    position: "bottom-left",
                    autoClose: 10000,
                    hideProgressBar: false,
                    closeOnClick: false,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                this.setState({
                    showTimesUp: true,
                    isTimeFinish: true,
                    showClock: false
                });
            }
        }
    }

    renderTimesUp = () => {
        if (this.state.showTimesUp) {
            const Confetti = this.state.Clock.ConfettiTimesUp;
            const CustomConfetti = this.state.Clock.CustomConfettiTimesUp;
            let src = "";
            if (Confetti !== 'custom' && Confetti !== 'none') {
                if (Confetti === 'random') {
                    src = this.times_up[Math.floor(Math.random() * this.times_up.length)].url;
                } else {
                    src = process.env.PUBLIC_URL + Confetti;
                }
            } else if (Confetti === 'custom' && CustomConfetti) {
                src = CustomConfetti;
            }

            if (this.props.isMission) {
                src = this.times_up[Math.floor(Math.random() * this.times_up.length)].url;
            }

            if (src) {
                return (
                    <div className="position-fixed w-100" style={{
                        pointerEvents: 'none',
                        padding: '20%',
                        top: '50%',
                        left: '50%',
                        zIndex: 1009,
                        transform: 'translate(-50%, -50%)'
                    }}>
                        <Player
                            onEvent={event => {
                                if (event === 'complete') {
                                    this.setState({
                                        showTimesUp: false
                                    });
                                }
                            }}
                            autoplay
                            loop={false}
                            src={src}
                            style={{ height: '100%', width: '100%' }} />
                    </div>
                );
            }
        }
    }

    sumQuestion() {
        let result = { count: 0, mark: 0, level: 0 };
        if (this.state.Questions) {
            this.state.Questions.forEach(function (item) {
                if (item.Type.Id !== 11) {
                    result.mark += item.Mark;
                    result.count++;
                    result.level += item.Level.Id;
                }
            });
        }
        return result;
    }

    sumTotalQuestions() {
        let sum = 0;
        this.props.exam.marks.forEach(item => {
            sum += item.userMark;
        })
        return sum.toFixed(2);
    }

    renderQuestionResult = (question, key) => {
        const { t, exam } = this.props;
        let currentMark = 0;
        let currentMarkObject = exam.marks.filter(p => p.Id === question.Id)[0];
        if (currentMarkObject) {
            currentMark = currentMarkObject.userMark;
            currentMark = parseFloat(currentMark);
        }

        let background = "#ecffe8";
        if (question.Mark === currentMark) {
            background = "#ecffe8";
        } else if (question.Mark / 2 > currentMark) {
            background = '#fff5fd';
        } else if (question.Mark !== currentMark) {
            background = '#fffee8';
        }

        return (
            <div className="class-inner " key={key}>
                <div className="event-item" style={{
                    background: background ? `${background}` : '#fff'
                }}>
                    <div className="event-content oh pb-2">
                        <div className="row row-col-2">
                            <div className="col p-0">
                                <div className="text-right text-dark h6 font-weight-bold"> <i className="icon fas fa-question text-primary"></i>
                                    <u>
                                        {t('Pages.Lessons.Questions.forms.Question')}  {key + 1}
                                    </u>
                                </div>
                            </div>
                            <div className="col p-0">
                                <div className="text-left title text-danger h6">
                                    <i className="icon fas fa-tally"></i> {t('Pages.Lessons.Questions.forms.QuestionMark.title')} : {question.Mark}
                                </div>
                            </div>
                        </div>
                        <div className="mb-1">
                            <div dangerouslySetInnerHTML={{ __html: question.Name }}></div>
                        </div>
                        <ul className="events-info">
                            <li>
                                <i className="icon fas fa-tally"></i> {t('Pages.Exams.Mark')} :
                                <span className={`h6 ${question.Mark === currentMark ? "text-success" : question.Mark / 2 > currentMark ? "text-danger" : "text-warning"} `}> {currentMark} </span>
                                <span className="h5"> {t('Pages.Exams.From')} </span>
                                <span className="h6"> {question.Mark} </span>
                            </li>
                            <li>
                                <i className="icon fas fa-water-rise"></i> {t('Pages.Lessons.Questions.forms.QuestionLevel.title')} :
                                <span className={`text-${question.Level.Id === 1 ? "success" : question.Level.Id === 2 ? "warning" : "danger"}`}>
                                    {question.Level.Name}
                                </span>
                            </li>
                        </ul>

                        <div className="my-1" style={{
                            borderBottom: '1px solid #e5e5e5',
                            marginRight: '-40px',
                            marginLeft: '-40px'
                        }}>
                        </div>
                        <div className="row">
                            <div className="col px-0 d-flex align-items-center " >
                                <div className="cursor-pointer" title={t('Pages.Exams.SeeResult')} onClick={() => this.openQuestionResult(question.Id)}>
                                    <i className="icon text-primary  fas fa-eye"></i>
                                    {t('Pages.Exams.SeeResult')}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    openQuestionResult = id => {
        const question = this.state.Questions.filter(p => p.Id === id)[0];
        if (question) {
            this.setState({
                showQuestionModal: true,
                showResult: true,
                question
            });
        }
    }

    ShowQuestionResult = () => {
        this.setState({
            ShowQuestionResult: !this.state.ShowQuestionResult
        });
    }


    renderStartPage() {
        const sum = this.sumQuestion();
        let textLevel = "";
        let levelIcon = "";
        if (sum.count > 0) {
            var level = Math.round(sum.level / sum.count);
            if (level === 1) {
                textLevel = configData.QuestionLevel[0].label;
                levelIcon = <i className="text-success icon fad fa-circle" title={textLevel}></i>;
            } else if (level === 2) {
                textLevel = configData.QuestionLevel[1].label;
                levelIcon = <i className="text-warning icon fad fa-circle" title={textLevel}></i>;
            } else if (level === 3) {
                textLevel = configData.QuestionLevel[2].label;
                levelIcon = <i className="text-danger icon fad fa-circle" title={textLevel}></i>;
            }
        }
        const { t } = this.props;

        return (
            <section className={`pos-rel padding-bottom padding-top  pt-5`}>
                <div className="row mt-0" id="bookWapper" >
                    <style dangerouslySetInnerHTML={{
                        __html: `html{background-position: 50% 50%;height: 100vh;background-size: cover;background-attachment:fixed;background-repeat: no-repeat;background-image: ${this.state.Background !== '' ? "url('" + this.state.Background + "?v=1')" : ""};}body{background: unset;}`
                    }}></style>
                    <Helmet>
                        <title>{this.state.Name} | {t('alarabeyya')}</title>

                        <meta property="og:title" content={this.state.Name + ' | ' + t('alarabeyya')} />
                        <meta property="twitter:title" content={this.state.Name + ' | ' + t('alarabeyya')} />

                        <meta name="description" content={this.state.Bio} />
                        <meta property="og:description" content={this.state.Bio} />
                        <meta property="twitter:description" content={this.state.Bio} />
                    </Helmet>
                    <div className="col-sm-11 col-md-11  col-lg-10 col-xl-8 mx-auto ">
                        <div className="post-item mb-30 mx-1 ">
                            <div className="post-content position-relative oh" style={{
                                background: this.state.srcStartPage ? "rgb(255 255 255 / 20%)" : "rgb(255 255 255)",
                                borderRadius: '10px'
                            }}>
                                {
                                    this.state.srcStartPage ?
                                        <div className="position-absolute w-100 d-flex align-items-center justify-content-center xxx" style={{
                                            pointerEvents: 'none',
                                            top: '0',
                                            right: '0',
                                            height: '100%',
                                            background: '#fff',
                                            zIndex: -1
                                        }}>
                                            <Player
                                                autoplay
                                                loop
                                                src={this.state.srcStartPage}
                                                style={{ width: '100%', height: '100%' }}
                                            />
                                        </div> : ""
                                }
                                <div className="post-top" style={{ minHeight: "80vh" }}>
                                    <h2 className="title text-center pt-2 mt-0 display-3" style={{ lineHeight: 'initial' }}>
                                        <Link to="#">
                                            {this.state.Name}
                                        </Link>
                                    </h2>
                                    <div className="post-meta cate p-4 d-flex justify-content-between flex-wrap" style={{
                                        background: "rgb(255 255 255 / 70%)"
                                    }}>
                                        <Link to="#" className="h5 mx-auto">
                                            <i className="icon fas fa-question"></i>
                                            <span className="text-dark">
                                                {t('Pages.Exams.Count')} : {sum.count}
                                            </span>
                                        </Link>
                                        <Link to="#" className="h5 mx-auto">
                                            <i className="icon fas fa-tally"></i>
                                            <span className="text-dark">
                                                {t('Pages.Exams.Marks')} : {sum.mark}
                                            </span>
                                        </Link>
                                        <Link to="#" className="h5 mx-auto">
                                            {levelIcon}
                                            <span className="text-dark">
                                                {t('Pages.Exams.Level')} :  {textLevel}
                                            </span>
                                        </Link>
                                        {
                                            this.state.Clock ?
                                                <Link to="#" className="h5 mx-auto">
                                                    <i className="icon fal fa-stopwatch"></i>
                                                    <span className="text-dark">
                                                        {t('Pages.Exams.Time')} :
                                                        {this.state.Clock.TimeHour > 0 ?
                                                            " " + this.state.Clock.TimeHour + " " + t('Pages.Exams.Hour')
                                                            : ""
                                                        }
                                                        {
                                                            this.state.Clock.TimeHour > 0 && this.state.Clock.TimeMinutes > 0 ? <i className="fad fa-minus"></i> : ""
                                                        }
                                                        {this.state.Clock.TimeMinutes > 0 ? " " + this.state.Clock.TimeMinutes + " " + t('Pages.Exams.Minute') : ""}
                                                    </span>
                                                </Link> : ""
                                        }

                                    </div>
                                    <div className="text-center pt-5">
                                        <button onClick={() => this.openExam()} className="custom-button ">
                                            <span>{t("Pages.Exams.Start")}</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }

    openExam = () => {
        if (this.state.Clock) {
            let TimeHour = Math.floor(this.state.Clock.TimeHour * 3600);
            let TimeMinutes = Math.floor(this.state.Clock.TimeMinutes * 60);
            this.duration = TimeHour + TimeMinutes;
            this.yourTime = 0;
            if (this.duration > 0) {
                this.setState({
                    showClock: true
                });
            }
        }
        this.props.startExam();
    }

    saveExamAnswer = (id, typeId, answers, mark, userMark) => {
        this.props.saveExamAnswer(id, typeId, answers, mark, parseFloat(userMark));
    }

    showFinishExam = () => {
        if (!this.state.showEndQuizePage) {
            var QuestionsCount = this.state.Questions.filter(p => p.Type.Id !== 11).length;
            var AnswerCount = this.props.exam.current.length;
            if (QuestionsCount !== AnswerCount) {
                const { t } = this.props;
                this._toastId.current = toast(t('Processing'), {
                    position: "bottom-left",
                    autoClose: false
                });
                toast.update(this._toastId.current, {
                    render: () => <div>
                        <div className="h5"> <i className="icon fal fa-engine-warning"></i> {t('Pages.Exams.toast.Warning.Title')}</div>
                        <div className="h6">{t('Pages.Exams.toast.Warning.Body')}</div>
                    </div>,
                    type: toast.TYPE.WARNING,
                    position: "bottom-left",
                    autoClose: 10000,
                    hideProgressBar: false,
                    closeOnClick: false,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        }
        this.setState({
            showEndQuizePage: !this.state.showEndQuizePage
        });
    }

    showEndExam = () => {
        this.setState({
            showEndExam: true,
            showEndQuizePage: false,
            yourTime: this.yourTime
        }, () => {
            studentLiveObserver.triggerSnapshot(300);
        });

        const seconds = Math.floor(this.yourTime % 60);
        const minutes = Math.floor((this.yourTime / 60) % 60);
        const hour = Math.floor(this.yourTime / 3600);

        if (this.props.isMission === true) {
            const { exam, t, MissionId } = this.props;

            let _toastId = toast(t('Processing'), {
                position: "bottom-left",
                autoClose: false
            });
            toast.update(_toastId, {
                render: () => <div> <i className="fa-spin fas fa-spinner"></i> {t('Processing')} </div>,
                autoClose: false,
                closeOnClick: false,
            });

            api.post(`/MyMissions/${MissionId}`,
                {
                    answers: exam.current,
                    total: this.sumTotalQuestions(),
                    CustomeStyle: {
                        Clock: {
                            seconds,
                            minutes,
                            hour
                        }
                    }
                }
            ).then(response => {
                toast.update(_toastId, {
                    render: () => <div>
                        <div className="h5">
                            <i className="icon fal fa-shield-check"></i>
                            {t('Pages.Missions.save_toast.Title')}
                        </div>
                        <div className="h6">
                            {t('Pages.Missions.save_toast.Body')}
                        </div>
                    </div>,
                    type: toast.TYPE.INFO,
                    position: "bottom-left",
                    autoClose: 10000,
                    hideProgressBar: false,
                    closeOnClick: false,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });

            }).catch(error => {
                toast.update(_toastId, {
                    render: () => <div><div className="h5"> <i className="icon fal fa-wifi-slash"></i> {t('Error.NoConnection.Title')}</div> <div className="h6">{t('Error.NoConnection.Body')}</div></div>,
                    type: toast.TYPE.ERROR,
                    position: "bottom-left",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: false,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            });
        } else {
            const { exam, t, lessons } = this.props;

            let _toastId = toast(t('Processing'), {
                position: "bottom-left",
                autoClose: false
            });
            toast.update(_toastId, {
                render: () => <div> <i className="fa-spin fas fa-spinner"></i> {t('Processing')} </div>,
                autoClose: false,
                closeOnClick: false,
            });

            api.post(`/UserLessonMark/${lessons.current.Id}`,
                {
                    answers: exam.current,
                    total: this.sumTotalQuestions(),
                    CustomeStyle: {
                        Clock: {
                            seconds,
                            minutes,
                            hour
                        }
                    }
                }
            ).then(response => {
                toast.update(_toastId, {
                    render: () => <div>
                        <div className="h5">
                            <i className="icon fal fa-shield-check"></i>
                            {t('Pages.Lessons.save_toast.Title')}
                        </div>
                        <div className="h6">
                            {t('Pages.Lessons.save_toast.Body')}
                        </div>
                    </div>,
                    type: toast.TYPE.INFO,
                    position: "bottom-left",
                    autoClose: 10000,
                    hideProgressBar: false,
                    closeOnClick: false,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });

            }).catch(error => {
                toast.update(_toastId, {
                    render: () => <div><div className="h5"> <i className="icon fal fa-wifi-slash"></i> {t('Error.NoConnection.Title')}</div> <div className="h6">{t('Error.NoConnection.Body')}</div></div>,
                    type: toast.TYPE.ERROR,
                    position: "bottom-left",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: false,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            });

        }

        setTimeout(() => {
            window.scrollToTop();
        }, 200);
    }

    handleClose = () => {
        setTimeout(() => {
            this.setState({
                showQuestionModal: false
            });
        }, 450);
    }

    openQuestion = id => {
        const question = this.state.Questions.filter(p => p.Id === id)[0];
        if (question) {
            this.setState({
                showQuestionModal: true,
                question
            });
        }
    }

    renderQuestionView = () => {
        const question = this.state.question;
        const { exam } = this.props;
        if (this.state.question) {
            return <QuestionView
                question={question}
                answers={question.Answers}
                key={question.Id}
                index={1}
                showResult={this.state.showResult}
                onEdit={false}
                solveButton={false}
                isExamQuestion={true}
                saveExamAnswer={this.saveExamAnswer}
                examAnswers={exam.current}
                FontSize={this.state.FontSize} />
        }
        return "";
    }

    renderFinishExam = () => {
        const { t } = this.props;
        var hasRights = this.state.Questions.some(p => p.Position === true && p.Type.Id !== 11);
        var hasLefts = this.state.Questions.some(p => p.Position === false && p.Type.Id !== 11);
        return (
            <>
                <section className={`mark-panel ${this.state.showEndQuizePage ? "show" : ""}`}  >
                    {
                        this.state.showEndQuizePage ?
                            <>
                                <div className="cross" onClick={() => this.showFinishExam()} title={t('Pages.Exams.Close')}  >
                                    <i className="fas fa-times"></i>
                                </div>
                                <div className="container mt-30">
                                    <div className="row justify-content-center">
                                        <div className="col-lg-8">
                                            <div className="section-header">
                                                <h3 className="title">{this.state.Name}</h3>
                                                <span className="cate">{t('Pages.Exams.EndExamSubTitle')}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row justify-content-md-center mb--10">
                                        <div className="position-relative w-100" style={{
                                            height: !hasRights || !hasLefts ? '100px' : 'auto'
                                        }}>
                                            {
                                                this.state.showClock ?
                                                    <CountdownCircle
                                                        duration={this.duration}
                                                        BackgroundBorderColor={this.state.Clock.BackgroundBorderColor}
                                                        TimeBorderColor={this.state.Clock.TimeBorderColor}
                                                    ></CountdownCircle>
                                                    : ""
                                            }
                                        </div>
                                        <div className={`col-lg-6 ${hasRights ? "" : "d-none"}`}>
                                            <div className={`section-header pt-3 ${hasLefts ? "" : "d-none"}`}>
                                                <h3 className="title">{t('Pages.Exams.RightSide')}</h3>
                                            </div>
                                            <div className="faq-wrapper">
                                                {
                                                    this.state.Questions.filter(p => p.Position === true && p.Type.Id !== 11).map((question, key) => {
                                                        return this.renderQuestionItem(question, key)
                                                    })
                                                }
                                            </div>
                                        </div>
                                        <div className={`col-lg-6 ${hasLefts ? "" : "d-none"}`}>
                                            <div className={`section-header pt-3 ${hasRights ? "" : "d-none"}`}>
                                                <h3 className="title">{t('Pages.Exams.LeftSide')}</h3>
                                            </div>
                                            <div className="faq-wrapper">
                                                {
                                                    this.state.Questions.filter(p => p.Position === false && p.Type.Id !== 11).map((question, key) => {
                                                        return this.renderQuestionItem(question, key)
                                                    })
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row justify-content-md-center mt-3">
                                        <div className="d-flex justify-content-center w-100">
                                            <div onClick={() => this.showEndExam()} className="theme-btn btn-style-two d-inline-flex mb-1">
                                                <span className="txt pl-2"> {t('Pages.Exams.EndExam')} </span>
                                                <div className="mouse-btn-down">
                                                    <div className="chevron"></div>
                                                    <div className="chevron"></div>
                                                    <div className="chevron"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                            : ""
                    }
                </section>
            </>
        );
    }

    renderQuestionItem(question, key) {
        const { t, exam } = this.props;
        let hasAnswer = false;
        if (exam.marks) {
            hasAnswer = exam.marks.some(p => p.Id === question.Id);
        }
        return (
            <div className="faq-item" key={`questionNumber-${key}`} onClick={() => this.openQuestion(question.Id)}>
                <div className="faq-title d-flex">
                    <span className="right-questionNumber">{key + 1}</span>
                    <h5 className="faq-item-questionTitle">  <div dangerouslySetInnerHTML={{ __html: question.Name }}></div></h5>
                    {
                        hasAnswer ? ""
                            :
                            <span className="mr-auto d-flex align-self-center" title={t('Pages.Exams.NoAnswer')}>
                                <i className="text-danger h5 mb-0 fas fa-engine-warning"></i>
                            </span>
                    }
                </div>
            </div>
        );
    }

    renderEndExam = () => {
        if (this.state.showEndExam) {
            const { t, user, lessons, isMission } = this.props;
            const examTotalMark = this.sumQuestion();
            const userMark = this.sumTotalQuestions();
            const markRate = Math.round(userMark / examTotalMark.mark * 100);
            let innerText = isMission ? t("Pages.Exams.FailedMissionIsEnded") : t("Pages.Exams.FailedExamIsEnded");
            let textColor = "text-danger";
            let renderReset = true;
            if (markRate === 100) {
                renderReset = false;
                textColor = "text-success";
                innerText = t("Pages.Exams.SuccessExamIsEnded");
                if (this.state.isTimeFinish === true) {
                    innerText = t("Pages.Exams.SuccessButTimesUp");
                }
            } else if (markRate >= 50) {
                textColor = "text-warning";
                innerText = t("Pages.Exams.SuccessExamIsEndedWithError");
                if (this.state.isTimeFinish === true) {
                    innerText = t("Pages.Exams.SuccessButTimesUpWithError");
                }
            }
            const seconds = Math.floor(this.state.yourTime % 60);
            const minutes = Math.floor((this.state.yourTime / 60) % 60);
            const hour = Math.floor(this.state.yourTime / 3600);

            return (
                <>
                    <section className={`pos-rel padding-bottom pt-0 ${this.state.ShowQuestionResult ? "" : "d-flex align-items-center justify-content-center h-100"}`}
                        style={{
                            minHeight: '100vh'
                        }}
                    >
                        {
                            markRate === 100 && this.state.src ?
                                <div className="position-fixed w-100 d-flex align-items-center justify-content-center" style={{
                                    pointerEvents: 'none',
                                    top: '0',
                                    right: '0',
                                    height: '100%',
                                    width: '100%',
                                    overflow: 'hidden',
                                    flexShrink: '0'
                                }}>
                                    <Player
                                        autoplay
                                        loop
                                        src={this.state.src}
                                        style={{ height: '100%' }}
                                    />
                                </div>
                                : ""
                        }
                        <style dangerouslySetInnerHTML={{
                            __html: `html{background-position: 50% 50%;height: 100vh;background-size: cover;background-repeat: no-repeat;background-attachment: fixed;background-image: ${this.state.Background !== '' ? "url('" + this.state.Background + "?v=1')" : ""};}body{background: unset;}`
                        }}></style>
                        <div className="class-section padding-bottom pos-rel w-100">
                            <div className="container-lg">
                                <div className="post-item mb-30 mx-1">
                                    <div className="post-content position-relative oh p-4" style={{
                                        borderRadius: this.state.ShowQuestionResult ? '0 0 10px 10px' : "10px"
                                    }}>
                                        <h2 className="title text-center pt-4 " >
                                            <Link to="#">
                                                {this.state.Name}
                                            </Link>
                                        </h2>
                                        <h4 className={`text-center pt-3 ${textColor}`}>
                                            {innerText}
                                        </h4>
                                        <div className="d-flex flex-wrap">

                                            <div className={`round-style`} title={t('Pages.Exams.Marks')} style={{
                                                flexDirection: 'row'
                                            }}>
                                                <div className={`${textColor}`}>{userMark}</div>
                                                <div className="mx-1">{t('Pages.Exams.From')}</div>
                                                <div>{examTotalMark.mark}</div>
                                                <i className={`px-1 fad fa-tally ${textColor}`}></i>
                                            </div>

                                            <div className={`circle-style ${textColor}`} title={t('Pages.Exams.MarkRate')}>
                                                {markRate}
                                                <i className="py-1 fad fa-percent"></i>
                                            </div>

                                            <div className={`round-style`} title={t('Pages.Exams.yourTime')} >
                                                {
                                                    hour > 0 ?
                                                        <>
                                                            <div title={t('Pages.Exams.Hour')} >{hour}</div>
                                                            <div>:</div>
                                                        </> : ""
                                                }
                                                <div title={t('Pages.Exams.Minute')}>{minutes < 10 ? "0" + minutes : minutes}</div>
                                                {
                                                    hour === 0 ?
                                                        <>
                                                            <div>:</div>
                                                            <div title={t('Pages.Exams.Second')}>{seconds < 10 ? "0" + seconds : seconds}</div>
                                                        </> : ""
                                                }
                                                <i className="icon fad fa-clock"></i>
                                            </div>
                                        </div>
                                        <div className="d-flex justify-content-evenly banner-buttons pt-5" style={{
                                            justifyContent: "space-evenly"
                                        }}>
                                            {
                                                this.props.isMission === true ?
                                                    "" :
                                                    <>
                                                        {
                                                            renderReset ?
                                                                <button onClick={() => this.resetExam()} className="custom-button ">
                                                                    <span>  <i className="icon fas fa-repeat-alt"></i> {t("Pages.Exams.ResetExam")}</span>
                                                                </button>
                                                                : ""
                                                        }
                                                        {
                                                            !lessons.current.isRated && !this.state.hideRate && user && user.user && user.user.UserType && user.user.UserType.Id !== 5 ?
                                                                <button onClick={() => this.showRate()} className="custom-button ">
                                                                    <span>  <i className="icon fas fa-star"></i> {t("Pages.Lessons.tools.rate")}</span>
                                                                </button>
                                                                : ""
                                                        }
                                                    </>
                                            }
                                            <button onClick={() => this.ShowQuestionResult()} className="custom-button info-button">
                                                <span>
                                                    {
                                                        this.state.ShowQuestionResult ?
                                                            <i className="icon fas fa-eye-slash"></i>
                                                            :
                                                            <i className="icon fas fa-eye"></i>
                                                    }
                                                    {t("Pages.Exams.ShowQuestionResult")}
                                                </span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                {
                                    this.state.ShowQuestionResult ?
                                        <div className="mb-30 ">
                                            <div className="class-wrapper d-flex flex-wrap align-items-stretch mb-2">
                                                {
                                                    this.state.Questions.filter(p => p.Position === true && p.Type.Id !== 11).map((question, key) => {
                                                        return this.renderQuestionResult(question, key)
                                                    })
                                                }
                                            </div>
                                            <div className="class-wrapper d-flex flex-wrap align-items-stretch">
                                                {
                                                    this.state.Questions.filter(p => p.Position === false && p.Type.Id !== 11).map((question, key) => {
                                                        return this.renderQuestionResult(question, key)
                                                    })
                                                }
                                            </div>
                                        </div>
                                        : ""
                                }
                            </div>
                        </div>
                    </section>
                </>
            );
        }
        return "";
    }

    resetExam = () => {
        window.location.reload(false);
    }

    showRate = () => {
        this.setState({
            showRate: !this.state.showRate
        });
    }

    hideRate = () => {
        this.setState({
            showRate: false,
            hideRate: true
        });
    }

    render() {
        const { t, exam, lessons, user } = this.props;
        if (lessons.length === 0) {
            return <Loading />
        }
        return (
            <>
                {
                    !lessons.current.isRated && !this.state.hideRate && user && user.user && user.user.UserType && user.user.UserType.Id !== 5 && this.state.showRate ?
                        <Rate
                            id={lessons.current.Id}
                            IsForLesson={true}
                            hideRate={this.hideRate}
                            showRate={this.showRate} />
                        : ""
                }
                {
                    this.state.showQuestionModal ?
                        <ShowQuestionModal renderQuestionView={this.renderQuestionView} showResult={this.state.showResult} handleClose={this.handleClose} />
                        : ""
                }
                {
                    !this.state.showSound ?
                        <style dangerouslySetInnerHTML={{ __html: `html{width: calc(100% - 15px);overflow-x: unset;}header{ display:none; }body{overflow-x: hidden;}section{padding-top:5px !important;padding-bottom:5px !important;}` }}></style>
                        :
                        <style dangerouslySetInnerHTML={{ __html: `html{width: calc(100% - 15px);overflow-x: unset;}header{ display:none; }body{overflow-x: hidden;}section{padding-top:5px !important;}` }}></style>
                }
                {this.renderTimesUp()}
                {
                    (!exam || exam.length === 0) ? this.renderStartPage() :
                        <>
                            {
                                this.state.showEndQuizePage || this.state.showEndExam ? "" :
                                    <>
                                        <View
                                            {...this.props}
                                            showSound={this.showSound}
                                            IndexId={this.state.IndexId}
                                            duration={this.duration}
                                            examAnswers={exam.current}
                                            key={this.state.Id}
                                            Id={this.state.Id}
                                            Name={this.state.Name}
                                            Sound={this.state.Sound}
                                            Url={this.state.Url}
                                            Questions={this.state.Questions}
                                            LessonPage={this.state.LessonPage}
                                            Clock={this.state.Clock}
                                            showClock={this.state.showClock}
                                            questionSeparated={this.state.questionSeparated}
                                            QuestionToRemove={[]}
                                            FontSize={this.state.FontSize}
                                            Background={this.state.Background}
                                            isOnEdit={false}
                                            isExamQuestion={true}
                                            saveExamAnswer={this.saveExamAnswer}
                                        />
                                        <div className="d-flex justify-content-center">
                                            <div onClick={() => this.showFinishExam()} className="theme-btn btn-style-two d-inline-flex mb-1">
                                                <span className="txt pl-2"> {t('Pages.Exams.showEndExam')} </span>
                                                <div className="mouse-btn-down">
                                                    <div className="chevron"></div>
                                                    <div className="chevron"></div>
                                                    <div className="chevron"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                            }
                        </>
                }
                {this.renderFinishExam()}
                {this.renderEndExam()}
            </>
        );
    }
}

const mapStateToProps = state => {
    return {
        user: state.user,
        lessons: state.lessons,
        indices: state.indices,
        exam: state.exam
    };
};

export default connect(mapStateToProps, { fetchIndices, fetchLesson, startExam, saveExamAnswer })(withTranslation('common')(ExamView));